import React, { useEffect, useRef, useState } from "react";
import { MoreHorizontal } from "lucide-react";

// A clean popover menu that reveals on row hover. Parent row must use `.group`.
// Items: [{ icon, label, onClick, danger?, testid?, disabled? }]
export function ActionPopover({ items, testid, always = false, align = "right" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  return (
    <div
      ref={ref}
      className={`relative shrink-0 transition-opacity ${
        always || open ? "opacity-100" : "opacity-0 group-hover:opacity-100 focus-within:opacity-100"
      }`}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
        data-testid={testid || "action-popover-trigger"}
        aria-label="Show actions"
        className="p-1.5 rounded-sm border border-neutral-200 bg-white text-neutral-500 hover:text-neutral-900 hover:border-neutral-400 hover:bg-neutral-100 transition-colors"
      >
        <MoreHorizontal size={14} />
      </button>
      {open && (
        <div
          className={`absolute top-full mt-1 min-w-[220px] rounded-md border border-neutral-200 bg-white shadow-lg py-1 z-40 ${align === "right" ? "right-0" : "left-0"}`}
          onClick={(e) => e.stopPropagation()}
          data-testid={`${testid || "action-popover"}-list`}
        >
          {items.filter(Boolean).map((it, i) => (
            <button
              key={i}
              onClick={() => { setOpen(false); it.onClick(); }}
              disabled={it.disabled}
              data-testid={it.testid}
              className={`w-full flex items-center gap-2.5 px-3 py-2 text-sm text-left hover:bg-neutral-100 transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${
                it.danger ? "text-red-600" : "text-neutral-800"
              }`}
            >
              <span className="text-neutral-500 shrink-0">{it.icon}</span>
              <span className="truncate">{it.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
